function readCookie(name) {
  // Match start-of-string or semicolon + optional space, then name=value until next ; or end
  const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}

function getFbc() {
  return readCookie('_fbc');
}

function getFbp() {
  return readCookie('_fbp');
}

function sanitizeCookiesForReporting(cookieString) {
  // Extract only Facebook-related cookies to avoid exposing sensitive data
  const fbCookies = {};
  const cookies = cookieString.split(';');

  cookies.forEach((cookie) => {
    const trimmed = cookie.trim();
    if (trimmed.startsWith('_fbc=') || trimmed.startsWith('_fbp=')) {
      const [name, value] = trimmed.split('=');
      fbCookies[name] = value;
    }
  });

  return {
    hasFbc: cookieString.includes('_fbc'),
    hasFbp: cookieString.includes('_fbp'),
    fbCookies,
    cookieCount: cookies.length,
  };
}

function reportFbcIssue(fbc, allCookies) {
  try {
    // Check if Bugsnag is available (it's injected in the Nuxt context)
    if (typeof window !== 'undefined' && window.$nuxt && window.$nuxt.$bugsnag) {
      const bugsnag = window.$nuxt.$bugsnag;

      if (fbc === null) {
        const cookieStringContainsFbc = allCookies.includes('_fbc');
        const sanitizedCookies = sanitizeCookiesForReporting(allCookies);

        if (cookieStringContainsFbc) {
          // Cookie exists but regex failed to read it
          bugsnag.leaveBreadcrumb('FBC cookie read failure', {
            type: 'regex_failure',
            ...sanitizedCookies,
          });
          bugsnag.notify(
            new Error('FBC Cookie Read Error: Regex or timing issue'),
            (event) => {
              event.severity = 'warning';
              event.context = 'sessionData:getFbc';
            }
          );
        } else {
          // Cookie doesn't exist at all
          bugsnag.leaveBreadcrumb('FBC cookie missing', {
            type: 'cookie_missing',
            ...sanitizedCookies,
          });
          bugsnag.notify(
            new Error('FBC Cookie Missing: Cookie lifetime or scope issue'),
            (event) => {
              event.severity = 'info';
              event.context = 'sessionData:getFbc';
            }
          );
        }
      }
    }
  } catch (e) {
    // Silently fail if Bugsnag reporting fails
    console.log('Failed to report FBC issue to Bugsnag', e);
  }
}

function computeSessionData() {
  const sessionData = {};
  try {
    sessionData.url = window.location.href;
    sessionData.userAgent = navigator.userAgent;
    sessionData.fbc = getFbc();
    sessionData.fbp = getFbp();

    // Report FBC cookie issues to Bugsnag
    const allCookies = document.cookie;
    reportFbcIssue(sessionData.fbc, allCookies);
  } catch (e) {
    console.log(e);
  }
  return sessionData;
}

module.exports.get = computeSessionData;
